import { render, staticRenderFns } from "./OrganizationMembers.vue?vue&type=template&id=28a5fab1&scoped=true"
import script from "./OrganizationMembers.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationMembers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationMembers.vue?vue&type=style&index=0&id=28a5fab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5fab1",
  null
  
)

export default component.exports